import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=62f3a64a&scoped=true&"
import script from "./badge.vue?vue&type=script&lang=js&"
export * from "./badge.vue?vue&type=script&lang=js&"
import style0 from "./badge.vue?vue&type=style&index=0&id=62f3a64a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f3a64a",
  null
  
)

export default component.exports